import DangerText from "./DangerText";

export * from ".";
export default DangerText;